export default {
    translations: {
      loginPage: {
        welcome: 'Bienvenido',
        document: 'DNI',
        action: 'Avanzar',
        invalidUser: 'Usuario en proceso de registro o no registrado'
      },
      errorPage: {
        backbutton: 'Volver',
        header: 'Accede a la Smart Fit App para programar una nueva cita.',
        subtitle: 'La experiencia de la app es mucho mejor. A través de ella puedes acceder a tus entrenamientos, programar y reprogramar nuevas citas y recibir notificaciones para no perderte nada.',
        download: '¡Descarga ahora!',
        action: 'Descargar App'
      },
      schedulePage: {
        title: 'Ahora elige el mejor día y hora para tu consulta',
        loading: 'Por favor, espere. Buscando fechas disponibles para citas...',
        unavailable: 'Parece que no hay horarios disponibles para este día',
        datePreposition: 'de',
        action: 'Avanzar'
      },
      confirmationPage: {
        title: '¡Cita asignada con éxito!',
        datePreposition: 'a las',
        coach: 'Coach',
        reschedule: 'Reprogramar',
        important: '¡Importante!',
        downloadInfo: 'Descárgate nuestra aplicación. ¡Te permitirá recibir tus entrenamientos para realizarlos donde quieras!',
        downloadAction: 'descargar la app Smart Fit',
        callInfo: 'La videollamada se realizará por Whatsapp. Tu Coach se pondrá en contacto contigo 10 minutos antes de la cita.',
        confirmationInfo: 'Si no puedes asistir, anula tu cita',
        confirmationInfoBold: 'con al menos 12 horas de antelación',
        confirmationInfoTwo: 'Si cancelas con menos tiempo, sólo podrás reprogramar una semana más tarde.',
        action: 'Ir al sitio de Smart Fit',
        modal: {
          title: 'utiliza nuestra app',
          subtitle: 'Allí podrás cancelar y reprogramar tus citas fácilmente y recibir notificaciones para no perderte ninguna cita.',
          subtitleBold: '¡Descargar ahora!',
          subtitleAppBold: 'Descárgalo ahora y accede con tu RUT registrado en Smart Fit Coach.',
          appAction: 'descargar Smart Fit'
        }
      },
      utils: {
        monthsAbbr: {
          january: 'ene',
          february: 'feb',
          march: 'mar',
          april: 'abr',
          may: 'may',
          june: 'jun',
          july: 'jul',
          august: 'ago',
          september: 'sep',
          october: 'oct',
          november: 'nov',
          december: 'dic'
        },
        weekDaysAbbr: {
          sunday: 'dom',
          monday: 'lun',
          tuesday: 'mar',
          wednesday: 'mie',
          thursday: 'jue',
          friday: 'vie',
          saturday: 'sab',
        },
        languages: {
          pt_BR: 'Portugués - Brasil',
          es_CL: 'Español - Chile',
          es_CO: 'Español - Colombia',
          es_MX: 'Español - México',
          es_PE: 'Español - Peru',
          es_PA: 'Español - Panamá',
          es_CR: 'Español - Costa Rica',
        }
      },
    }
  }
